import React from 'react';
import PropTypes from 'prop-types';
import { MChip } from '../../atoms/MChip';
import { MBox } from '../../atoms/MBox';
import MFlexbox from '../../atoms/MFlexbox';

export default function AddedVariantsChips({
  addedVariants,
  addedVariantsPrefix,
  showQty = true,
  chipColor = 'black',
  chipBorderColor = 'black',
  margin = '4px 0px 8px 0px',
  alignment = 'left',
}) {
  return (
    <MBox className="mr-added-variants-chips" margin={margin}>
      {addedVariantsPrefix && (
        <span className="mr-added-variants-chips__prefix">
          {addedVariantsPrefix}
        </span>
      )}

      <MFlexbox
        className="mr-added-variants-chips__variants-list"
        gap="4px"
        jc={alignment}
      >
        {Object.keys(addedVariants).map(key => (
          <MChip
            color={chipColor}
            borderColor={chipBorderColor}
            margin="0px"
            text={`${key}${showQty ? ` * ${addedVariants[key]}` : ''}`}
            className="mr-added-variants-chips__variants-list-item"
          />
        ))}
      </MFlexbox>
    </MBox>
  );
}

AddedVariantsChips.propTypes = {
  addedVariants: PropTypes.object.isRequired,
  addedVariantsPrefix: PropTypes.string.isRequired,
  showQty: PropTypes.bool,
  chipColor: PropTypes.string,
  chipBorderColor: PropTypes.string,
  margin: PropTypes.string,
  alignment: PropTypes.string,
};
